import moment from "moment";

const ExelJS = require("exceljs");

const exportToExcel = (sheets) => {
  const workbook = new ExelJS.Workbook();
  sheets.forEach((sheetData, index) => {
    const sheet = workbook.addWorksheet(sheetData.name);

    sheet.addRow([]);
    sheet.mergeCells(
      `A1`,
      `${String.fromCharCode(65 + sheetData.header.length - 1)}1`
    );
    sheet.getCell("A1").value = sheetData.title;

    // sheet.addRow([]);

    // sheet.getCell("C2").value = "PROPERTY";
    // sheet.getCell("D2").value = sheetData?.titleData?.property;

    // // if(sheetData?.titleData?.rmsInHotel !== ""){
    // sheet.getCell("C3").value = "# RMS IN HOTEL";
    // sheet.getCell("D3").value = sheetData?.titleData?.rmsInHotel;
    // // }

    // sheet.getCell("E2").value = "MONTH/YEAR :";
    // sheet.getCell("F2").value = sheetData?.titleData?.month;

    // sheet.getCell("E3").value = "# DAYS";
    // sheet.getCell("F3").value = sheetData?.titleData?.days;

    // const allCell = ["C2", "C3", "D2", "D3", "E2", "E3", "F2", "F3", "B5"];
    // const cellsToApplyBorders = ["D2", "D3", "F2", "F3", "B5"];
    // allCell.forEach((cellAddress) => {
    //   const cell = sheet.getCell(cellAddress);
    //   if (cellsToApplyBorders?.includes(cellAddress)) {
    //     cell.border = {
    //       top: { style: "medium" },
    //       bottom: { style: "medium" },
    //       left: { style: "medium" },
    //       right: { style: "medium" },
    //     };
    //   }
    //   cell.font = { bold: true, size: 12 };
    //   cell.alignment = {
    //     wrapText: true,
    //     vertical: "middle",
    //     horizontal: "center",
    //   };
    // });
    sheet.getCell("A1").font = { bold: true, size: 14 };
    sheet.getCell("A1").fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "B2B2B2" },
    }; // Set background color
    sheet.getCell("A1").border = {
      top: { style: "medium" },
      bottom: { style: "medium" },
      left: { style: "medium" },
      right: { style: "medium" },
    }; // Set border
    sheet.columns = sheetData?.header?.map((item) => ({
      // header: item,
      key: item,
      width: 20,
    }));

    sheetData?.data?.map((rowData, index) => {
      const dataRow = sheet?.addRow(rowData);
      dataRow.eachCell((cell, colNumber) => {
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.border = {
          left: { style: "medium" },
          right: { style: "medium" },
        };
        if (index === 0) {
          cell.alignment = {
            wrapText: true,
            vertical: "middle",
            horizontal: "center",
          };
          cell.border = {
            top: { style: "medium" },
            bottom: { style: "medium" },
            left: { style: "medium" },
            right: { style: "medium" },
          };
          cell.font = { bold: true, size: 12 };
        }
        if (index >= sheetData?.data?.length - 2) {
          cell.border = {
            // top: { style: "medium" },
            // bottom: { style: "medium" },
            left: { style: "medium" },
            right: { style: "medium" },
          };
          cell.font = { bold: true, size: 12 };
        }
        if (index === sheetData?.data?.length - 1) {
          cell.border = {
            // top: { style: "medium" },
            bottom: { style: "medium" },
            left: { style: "medium" },
            right: { style: "medium" },
          };
          // cell.fill = {
          //   type: "pattern",
          //   pattern: "solid",
          //   fgColor: { argb: "B2B2B2" },
          // }; // Set background color
        }
        // if (colNumber === 0 || colNumber === 1) {
        //   cell.border = {
        //     top: { style: "hair" },
        //     bottom: { style: "hair" },
        //     left: { style: "hair" },
        //     right: { style: "hair" },
        //   };
        //   cell.fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: { argb: "FFFFFF" },
        //   }; // Set background color
        // }
      });
    });
    sheet.getCell(
      `${String.fromCharCode(65 + sheetData.header.length - 1)}2`
    ).border = { right: { style: "medium" }, bottom: { style: "medium" } };

    for (let i = 1; i <= sheet?.rowCount; i++) {
      const row = sheet.getRow(i);

      //Now loop through every row's cell and finally set alignment
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true,
        };
        // cell.border = {right: { style: "medium" },}
      });
      // console.log(row?._number, 138)
      if (+row?._number > 2) {
        sheet.getCell(
          `${String.fromCharCode(
            65 + sheetData.header.length - 1
          )}${+row?._number}`
        ).border = { right: { style: "medium" } };
      }
      if (row?._number === sheet?.rowCount) {
        sheet.getCell(
          `${String.fromCharCode(
            65 + sheetData.header.length - 1
          )}${+row?._number}`
        ).border = { right: { style: "medium" }, bottom: { style: "medium" } };
      }
    }
  });

  const hotelDetail = JSON.parse(localStorage.getItem("userDetails"));

  workbook.xlsx.writeBuffer().then((data) => {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = globalThis.URL.createObjectURL(blob);
    const a = document.createElement("a");
    // document.body.appendChild(a);
    a.href = url;
    a.download =
      hotelDetail?.hotelDetail?.company_name +
      " " +
      sheets[0]?.name +
      "_" +
      moment().format("MM-DD-YYYY");
    a.click();
    globalThis.URL.revokeObjectURL(url);
    // document.body.removeChild(a);
  });
};

export const ExportToExelCompo = (props) => {
  let { searchFilters, datagridPrintOptions, datagridColumns, name, title } =
    props;
  const items = JSON.parse(localStorage.getItem("userDetails"));

  let flashtitleData = {
    property: items?.hotelDetail?.company_name,
    rmsInHotel: "",
    month: moment(searchFilters?.startDate).format("MMM-YY"),
    days:
      +moment(searchFilters?.endDate).diff(searchFilters?.startDate, "days") +
      1,
  };
  // console.log(
  //   searchFilters,
  //   datagridPrintOptions,
  //   datagridColumns,
  //   name,
  //   title,
  //   6
  // );
  // console.log(datagridColumns, 213)

  let datagridColumn = datagridColumns?.filter(
    (item) => item?.headerName !== "Chat" && item?.headerName !== "Actions"
  );

  let flashHeader = [
    // "column0"
  ];
  datagridColumn?.forEach((item, i) => {
    flashHeader?.push(`column${+i + 1}`);
  });

  let flashHeaderObj = datagridColumn?.map((item, i) => ({
    col: `column${+i + 1}`,
    name: item?.headerName,
    field: item?.field,
  }));

  let flashArrayObj = {
    // column0: ""
  };
  for (let i in flashHeaderObj) {
    flashArrayObj[flashHeaderObj[i]?.col] = flashHeaderObj[i]?.name;
  }

  let flashArray = [];
  flashArray.push(flashArrayObj);

  let rowData = datagridPrintOptions?.rows;
  for (let i in rowData) {
    let obj = {
      // column0: ""
    };
    for (let j in flashHeaderObj) {
      // console.log(rowData[i][flashHeaderObj[j]?.field], i, j, 666);
      obj[flashHeaderObj[j]?.col] = rowData[i][flashHeaderObj[j]?.field];
    }
    flashArray.push(obj);
  }

  let flashArrayEmptyObj = {
    // column0: ""
  };
  for (let i in flashHeaderObj) {
    flashArrayEmptyObj[flashHeaderObj[i]?.col] = "";
  }
  flashArray.push(flashArrayEmptyObj);
  flashArray.push(flashArrayEmptyObj);

  // console.log(flashHeader, flashHeaderObj,flashArrayObj,flashArray, 66);

  let sheets = [
    {
      name: name,
      title: title,
      data: flashArray,
      header: flashHeader,
      titleData: flashtitleData,
      date: searchFilters?.startDate,
    },
  ];
  exportToExcel(sheets);
};
